import { myGymProgram as types } from '../actions/actiontypes'

const initState = {
  ongoing: [],
  programs: {},
  delete: {},
  errors: {},
  mode: 'view',
  showDuplicateDialog: null,
  currentCopyProgram: '',
  currentCopySite: '',
  copyResult: [],
  copyProgress: '',
}

function addToOngoing(state, action) {
  return [
    ...state,
    {
      id: action.id,
      what: action.what,
    },
  ]
}

function removeFromOngoing(state, action) {
  return state.filter(o => o.id != action.id)
}

function addToDeleted(state, action) {
  return Object.assign({}, state, {
    [action.id]: 'deleted',
  })
}

function addToProgram(state, action) {
  return Object.assign({}, state, {
    [action.id]: action.programs,
  })
}

function removeFromProgram(state, action) {
  let { [action.id]: omit, ...res } = state
  return res
}

function addToError(state, action) {
  return Object.assign({}, state, {
    [action.id]: action.error,
  })
}

export function myGymProgramReducer(state = initState, action) {
  switch (action.type) {
    case 'STORE_RESET':
      return {
        ...initState,
      }
    case types.GET:
    case types.SAVE:
    case types.DELETE:
    case types.DUPLICATE:
      return {
        ...state,
        ongoing: addToOngoing(state.ongoing, action),
        errors: {},
      }
    case types.RESPONSE:
      return {
        ...state,
        ongoing: removeFromOngoing(state.ongoing, action),
        programs: addToProgram(state.programs, action),
      }
    case types.SAVE_RESPONSE:
      return {
        ...state,
        ongoing: removeFromOngoing(state.ongoing, action),
        programs: addToProgram(state.programs, action),
        mode: 'view',
      }
    case types.DELETE_RESPONSE:
      return {
        ...state,
        ongoing: removeFromOngoing(state.ongoing, action),
        programs: removeFromProgram(state.programs, action),
        delete: addToDeleted(state.delete, action),
      }
    case types.DUPLICATE_RESPONSE:
      return {
        ...state,
        ongoing: removeFromOngoing(state.ongoing, action),
        showDuplicateDialog: {
          _id: action.programs._id,
          name: action.programs.name,
        },
      }
    case types.COPY_RESPONSE:
      return {
        ...state,
        ongoing: removeFromOngoing(state.ongoing, action),
      }
    case types.GET_FAIL:
    case types.SAVE_FAIL:
    case types.DELETE_FAIL:
    case types.DUPLICATE_FAIL:
      return {
        ...state,
        ongoing: removeFromOngoing(state.ongoing, action),
        errors: addToError(state.errors, action),
      }
    case types.DISMISS_DUPLICATE_DIALOG:
      return {
        ...state,
        showDuplicateDialog: null,
        mode: 'view',
      }
    case types.SET_MODE:
      return {
        ...state,
        mode: action.mode,
      }

    case types.SENDCOPY:
      return {
        ...state,
        ongoing: addToOngoing(state.ongoing, action),
        currentCopyProgram: action.program,
        currentCopySite: action.site,
        copyProgress: action.percentage,
      }
    case types.SENDCOPY_RESPONSE:
      return {
        ...state,
        ongoing: removeFromOngoing(state.ongoing, action),
        currentCopyProgram: '',
        currentCopySite: '',
        copyResult: [...state.copyResult, action.result],
        copyProgress: action.percentage,
      }
    case types.SENDCOPY_COMPLETE:
      return {
        ...state,
        ongoing: [],
        currentCopyProgram: '',
        currentCopySite: '',
        copyResult: [],
        copyProgress: '',
      }

    default:
      return state
  }
}
